import { FormControl, FormHelperText, MenuItem } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import MaterialSelect from "@material-ui/core/Select";
import React, { ReactNode } from "react";
import styled from "styled-components";

export type SelectProps = React.ComponentProps<typeof MaterialSelect> & {
  options: {
    title: ReactNode;
    value: string;
  }[];
  fullWidth?: boolean;
  helperText?: string;
};

const FormControlStyled = styled((props) => <FormControl {...props} />)`
  ${({ label }) => (label === undefined ? "margin-top: 0" : "")}
`;

export const Select = React.forwardRef<HTMLInputElement, SelectProps>(
  (props, ref) => {
    const {
      options,
      label,
      fullWidth,
      value,
      helperText,
      error,
      ...propsToPass
    } = props;

    return (
      <FormControlStyled
        variant="outlined"
        fullWidth={fullWidth}
        error={error}
        label={label}
      >
        {label ? (
          <InputLabel htmlFor={`select-${label}`}>{label}</InputLabel>
        ) : null}
        <MaterialSelect
          {...propsToPass}
          inputProps={{
            name: label,
            id: `select-${label}`,
          }}
          inputRef={ref}
          value={value || ""}
        >
          {options.map(({ title, value }) => (
            <MenuItem key={value} value={value}>
              {title}
            </MenuItem>
          ))}
        </MaterialSelect>
        {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
      </FormControlStyled>
    );
  }
);
